export const AUDIO_VISIT_TYPE = "AUDIO";
export const VIDEO_VISIT_TYPE = "VIDEO";
